import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { courseListColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { publicImageProps } from "../../services/config";
import { digitsThree } from "../../utils/price";
import DefaultImage from "../../components/common/default-image/DefaultImage";
import CourseFilter from "./CourseFilter";

export default function CourseList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [productData, setProductData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const getProduct = async (params) => {
    const path = "admin/courses";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setProductData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getProduct({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getProduct(allFilter);
  };

  const data = [];

  productData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      showImage: item.image ? (
        <img
          className="w-10 h-10 rounded-md"
          {...publicImageProps(item.image, { variant: "thumb_" })}
        />
      ) : (
        <DefaultImage imgSize={26} imgClass={"!w-10 !h-10 rounded-md"} />
      ),
      price: `${digitsThree(item.price)}`,
      showDiscountPercent: `${item.discountPercent}%` || 0,
      createdAt: item.createdAt,
      faStatus:
        (item.status === "active"
          ? "فعال"
          : item.status === "pending"
          ? "انتظار"
          : "غیرفعال"),
    })
  );

  const navigate = useNavigate();

  const editProduct = (singleProduct) => {
    const newSingleProduct = productData.filter((item) => {
      return item._id == singleProduct.id;
    });
    console.log(newSingleProduct);
    navigate("/edit-course", { state: newSingleProduct[0] });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست دوره ها"} />
      <CourseFilter filterDataHandler={filterDataHandler} />
      <Pagination
        filterDataHandler={filterDataHandler}
        pagination={pagination}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={courseListColumns} rows={data} onEdit={editProduct} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
